export const carouselEvents = Object.freeze({
    NEXT_SLIDE_CLICK: 'carousel:next-slide',
    PREV_SLIDE_CLICK: 'carousel:prev-slide'
});
